"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Callout = _interopRequireDefault(require("../Callout"));
var styles = {
  "callout": "callout_INF7ob",
  "small": "small_2gIeMj"
}; 
require('./BasicCallout.css');
var BasicCallout = function BasicCallout(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    type = _ref.type,
    className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'basic-callout' : _ref$testId;
  return /*#__PURE__*/_react.default.createElement(_Callout.default, {
    className: (0, _classnames.default)(className, styles.callout),
    testId: testId,
    type: type
  }, /*#__PURE__*/_react.default.createElement("strong", null, title), /*#__PURE__*/_react.default.createElement("p", {
    className: styles.small
  }, subtitle));
};
var _default = exports.default = BasicCallout;
//# sourceMappingURL=BasicCallout.js.map